const MetadataSpec = require("./types/MetadataSpec.js");

// These come in pairs.
const NexusData = require("./types/metadata/NexusData.js");
const StoreBudgets = require("./types/metadata/StoreBudgets.js");
const GeocodingImporter = require("./types/metadata/GeocodingImporter");
const MarketingURL = require("./types/metadata/MarketingURL.js");
const CauditData = require("./types/metadata/CauditData.js");
const SmartBonus = require("./types/metadata/SmartBonus.js");
const DivisionAssignments = require("./types/metadata/DivisionAssignments.js");
const HRContactAssignments = require("./types/metadata/HRContactAssignments.js");
const LegalCounselAssignments = require("./types/metadata/LegalCounselAssignments.js");
const PropertyAccountantAssignments = require("./types/metadata/PropertyAccountantAssignments.js");
const SrPropertyAccountantAssignments = require("./types/metadata/SrPropertyAccountantAssignments.js");
const PCard = require("./types/metadata/PCard.js");

// We have to identify metadata forms by name rather than by
// component.  Requiring components will create circular references.
const FormNames = {
    Nexus: "METADATASPEC.NEXUSFORM",
    StoreBudgets: "METADATASPEC.STOREBUDGETS",
    GeocodingImporter: "METADATASPEC.GEOCODINGIMPORTER",
    MarketingURL: "METADATASPEC.MARKETINGURL",
    Caudit: "METADATASPEC.CAUDIT",
    SmartBonus: "METADATASPEC.SMARTBONUS",
    DivisionAssignments: "METADATASPEC.DIVISIONASSIGNMENTS",
    HRContactAssignments: "METADATASPEC.HRCONTACTASSIGNMENTS",
    LegalCounselAssignments: "METADATASPEC.LEGALCOUNSELASSIGNMENTS",
    PropertyAccountantAssignments: "METADATASPEC.PROPERTYACCOUNTANTASSIGNMENTS",
    SrPropertyAccountantAssignments: "METADATASPEC.SRPROPERTYACCOUNTANTASSIGNMENTS",
    PCard: "METADATASPEC.PCARD"
};

/**
 * A dictionary keyed on dbLazarus.tblUploadType class names, and valued on
 * metadata specs.
 * 
 * Also contains a FormNames property that are used to select metadata forms
 * within the MetadataBox component.
 *
 * The second parameter in the call to MakeSpec has to match the exported module name in
 * that spec file in types/metadata
 */
const MetadataSpecs = {
    CauditImporter: MetadataSpec.MakeSpec(FormNames.Caudit, CauditData.GetSpecData()),
    DevImport: MetadataSpec.MakeSpec(FormNames.Nexus, NexusData.GetSpecData()),
    FormNames: FormNames,
    GeocodingImporter: MetadataSpec.MakeSpec(FormNames.GeocodingImporter, GeocodingImporter.GetSpecData()),
    MarketingURLImport: MetadataSpec.MakeSpec(FormNames.MarketingURL, MarketingURL.GetSpecData()),
    NexusScanImport: MetadataSpec.MakeSpec(FormNames.Nexus, NexusData.GetSpecData()),
    NexusScanPracticeImport: MetadataSpec.MakeSpec(FormNames.Nexus, NexusData.GetSpecPracticeData()),
    DivisionAssignmentImporter: MetadataSpec.MakeSpec(FormNames.DivisionAssignments, DivisionAssignments.GetSpecData()),
    HRAssignmentImporter: MetadataSpec.MakeSpec(FormNames.HRContactAssignments, HRContactAssignments.GetSpecData()),
    LegalCounselImporter: MetadataSpec.MakeSpec(FormNames.LegalCounselAssignments, LegalCounselAssignments.GetSpecData()),
    PAAssignmentImporter: MetadataSpec.MakeSpec(FormNames.PropertyAccountantAssignments, PropertyAccountantAssignments.GetSpecData()),
    SPAAssignmentImporter: MetadataSpec.MakeSpec(FormNames.SrPropertyAccountantAssignments, SrPropertyAccountantAssignments.GetSpecData()),
    PCardImporter: MetadataSpec.MakeSpec(FormNames.PCard, PCard.GetSpecData()),
    SmartBonusImporter: MetadataSpec.MakeSpec(FormNames.SmartBonus, SmartBonus.GetSpecData()),
    StoreBudgetUploader: MetadataSpec.MakeSpec(FormNames.StoreBudgets, StoreBudgets.GetSpecData())
};

module.exports = MetadataSpecs;


// WEBPACK FOOTER //
// ./src/MetadataSpecs.js